export const AUTH_CONSTANTS = {
  RESPONSE_TYPE: 'code',
  RESPONSE_MODE: 'query',
  GRANT_TYPE: 'authorization_code',
  CODE_CHALLENGE_METHOD: 'S256',
  URL_PATH_LOGOUT: '/logout',
  URL_PATH_TOKEN: '/token',
  URL_PATH_AUTHORIZE: '/authorize'
};
